<template>
  <div >
      <div class="r-option-place r-center-flex r-isWrap">
        <InputCustom
          :rightIcon="true"
          :withError="false"
          v-model="request.search" 
          @keyup="setTime()" 
          @keydown="clearTime()" 
          @keydown.tab="setTime()" 
          @keyup.tab="clearTime()" 
          @keypress.enter="getData()" 
          placeholder="Search . . ."
          size='md'
        >
          <template #rightIcon>
            <div class="y-inputIcon r-center-flex">
                <img :src="require('@/assets/icons/others/search.svg')" alt="search">
            </div>
          </template>
        </InputCustom>

        <ButtonCustom
          class="r-ml-auto"
          @click="openModal()"
        >
            Tambah Data
        </ButtonCustom>
      </div>
     

      <TableCustom 
        :columns="columns" 
        :request="request" 
        :fetchData="fetchData"
        :data="data"
        @setSortBy="setSortBy"
        @setShow="setShow" 
        @getData="getData"
        @mouseleave="popup = null"
        @togglePopup="togglePopup"
        >

        <template #index="props">
          {{curNumber(props.index)}}
        </template>

        <template #created_at="props">
          {{convertDateTime(props.row.created_at)}}
        </template>

        <template #is_active="props">
            <ButtonCustom
                :type="props.row.is_active == 1 ? 'success' : 'error'"
                :loading="props.row.id == loading"
                @click.stop="clickUpdateStatus(props.row)"
            >
                {{props.row.is_active == 1 ? 'Aktif' : 'Tidak Aktif'}}
            </ButtonCustom>
        </template>

        <template #action="props">
          <div class="r-menu">
            <img class="r-is-clickable" :src="require('@/assets/icons/others/more.svg')" @click.prevent="popup = curNumber(props.index)">
            <div class="r-menu-items" v-if="popup == curNumber(props.index)" @mouseleave="popup = -1">
              <div class="r-menu-item y-black-text r-center-flex" @click.prevent="openModal('Ubah', props.row)">Ubah</div>
              <div class="r-menu-item y-red-text r-center-flex"  @click.prevent="openDeleteModal(props.row)">Hapus</div>
            </div>
          </div>
        </template>
    </TableCustom>

    <InputModal 
      v-if="modal == 'inputModal'" 
      :inputType="inputType"
      @resetData="resetData"
      @getData="getData"
      :tapi_class_id="tapi_class_id"
    ></InputModal>

    <DeleteModal
      v-if="modal == 'deleteModal'" 
      @resetData="resetData"
      @getData="getData"
    >
    </DeleteModal>

  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import common from '@/mixins/function/common'
import tableMixins from '@/mixins/tableMixins'
import selectMixins from '@/mixins/selectMixins'
import InputModal from './components/InputModal'
import DeleteModal from './components/DeleteModal'
import {
    convertDate
} from '@/common/timeformat'

export default {
  mixins: [common, tableMixins, selectMixins],
  components: {
    InputModal,
    DeleteModal,
  },
  mounted() {
    this.initData()
  },
  computed:{
    ...mapGetters({
        data: 'tapiClassDetail/getData',
        request: 'tapiClassDetail/getRequest',
    }),
    tapi_class_id(){
      return this.$route.params.tapi_class_id
    }
  },
  data: () => ({
    search: {
      semester: null
    },
    loading: null,
    columns: [
        {
            label: 'No',
            isSortable: false,
            fieldName: 'index',
            class: "r-table-firstColumn"
        },
        {
            label: 'Tanggal Pembuatan',
            isSortable: true,
            fieldName: 'created_at',
            class: ""
        },
        {
            label: 'Kelas',
            isSortable: true,
            fieldName: 'tapi_class_name',
            class: ""
        },
        {
            label: 'Dosen',
            isSortable: true,
            fieldName: 'lecture_name',
            class: ""
        },
        {
            label: 'Tipe',
            isSortable: false,
            fieldName: 'type',
            class: ""
        },
        {
            label: 'Urutan',
            isSortable: false,
            fieldName: 'order',
            class: ""
        },
        {
            label: 'Status',
            isSortable: true,
            fieldName: 'is_active',
            class: ""
        },
        {
            label: 'Aksi',
            isSortable: false,
            fieldName: 'action',
            class: "r-table-actionColumn"
        }
    ],
    modal: null,
    inputType: 'Tambahkan'
  }),
  methods:{
    ...mapActions({
      resetItem: 'tapiClassDetail/resetItem',
      setItem: 'tapiClassDetail/setItem',
      getTapiData: 'tapiClassDetail/fetchData',
      updateStatus: 'tapiClassDetail/updateStatus',
      getLectureData: 'user/getLectureData'
    }),
    openDeleteModal(item){
      this.setItem(item)
      this.modal = 'deleteModal'
    },
    openModal(type = 'Tambahkan', item = {}){
      if(type == 'Tambahkan') this.resetItem()
      else {
        const payload = {
          ...item,
          is_active: item.is_active == 1
        }
        this.setItem(payload)
      }
      this.modal = 'inputModal'
      this.inputType = type
    },
    async initData(){
      const breadcrumb = [
        {
          name: 'Daftar Kelas',
          link: {name: 'TapiClass'},
          current: false
        },
        {
          name: 'Daftar Dosen',
          link: {name: null},
          current: true
        }
      ]
      this.setActiveTab('Daftar Kelas')
      this.setBreadCrumb(breadcrumb)
      await this.getData()
      await this.getLectureData()
    },
    resetData(){
      this.modal = null; 
      this.resetItem()
    },
    async getData(type = 0) {
        this.fetchData = true
        if(type === 0) this.request.page = 1
        else this.request.page += type
        await this.getTapiData(this.tapi_class_id)
        this.fetchData = false
    },
    convertDate(value){
      if(!value) return '-'
      return convertDate(value)
    },
    async clickUpdateStatus(data){
      this.loading = data.id
      await this.updateStatus(data.id)
      this.loading = null
      await this.getData()
    }
  }
};
</script>